interface SetHeadersArgs {
  headers: HeadersInit;
  name: string;
  value: string;
}

export function setHeaderIfNotExists({ headers, name, value }: SetHeadersArgs): void {
  if (headers instanceof Headers) {
    if (!headers.has(name)) {
      headers.set(name, value);
    }
  } else if (Array.isArray(headers)) {
    const lowerHeaderName = name.toLowerCase();
    const hasHeader = headers.some(([key]) => key.toLowerCase() === lowerHeaderName);

    if (!hasHeader) {
      headers.push([name, value]);
    }
  } else if (headers !== null && headers !== undefined && typeof headers === 'object') {
    const lowerHeaderName = name.toLowerCase();
    const hasHeader = Object.keys(headers).some((key) => key.toLowerCase() === lowerHeaderName);

    if (!hasHeader) {
      const headersCopy = headers;

      headersCopy[name] = value;
    }
  }
}
